var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62117 1.00005C2.23065 0.609522 1.59748 0.609522 1.20696 1.00005C0.816433 1.39057 0.816433 2.02374 1.20696 2.41426L8.58579 9.79309L0.793046 17.5858C0.402522 17.9764 0.402522 18.6095 0.793046 19C1.18357 19.3906 1.81674 19.3906 2.20726 19L10 11.2073L17.7927 19C18.1833 19.3906 18.8164 19.3906 19.207 19C19.5975 18.6095 19.5975 17.9764 19.207 17.5858L11.4142 9.79309L18.793 2.41426C19.1836 2.02374 19.1836 1.39057 18.793 1.00005C18.4025 0.609522 17.7694 0.609523 17.3788 1.00005L10 8.37888L2.62117 1.00005Z",
    fill: "#4b4b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.e86306ed3ac0695ca3dddeb6cb0a1c75.svg";
export { ForwardRef as ReactComponent };